export default {
  title: '兑换统计',
  exchangeTime: '兑换时间',
  startDate: '开始时间',
  endDate: '结束时间',
  totalPointsConsumed: '消耗积分总量',
  totalGiftsExchanged: '累计兑换礼品数',
  unitGifts: '件',
  totalOrders: '兑换订单总数',
  unitOrders: '单',
  popularRankTitle: '热门兑换礼品排行',
  rankNo: '排名',
  giftDetail: '礼品详情',
  exchangeQty: '兑换数量',
  popularity: '热度占比',
  trendTitle: '近7天兑换情况',
  trendSeries: '兑换数量',
  rangeLimitTip: '兑换时间最多支持一年，下面数据根据查询条件变化',
};
